// src/components/job-engine/useJobEngineConnectionState.ts
import { useEffect, useState } from "react";
import { signalRService } from "./signalRService";

export function useJobEngineConnectionState(): boolean {
  const [isConnected, setIsConnected] = useState<boolean>(signalRService.isConnected());
  useEffect(() => {
    const cb = (next: boolean) => setIsConnected(next);
    signalRService.onStateChange(cb);
    return () => signalRService.offStateChange(cb);
  }, []);
  return isConnected;
}
